import gsap from 'gsap';
import {
	Sizes,
	generateAnimations,
	destroyAnimations,
	generateTriggers,
} from '../utils';

export class Click {
	constructor( selector, options = {} ) {
		// General
		this.elements = gsap.utils.toArray( selector );
		this.sizes = new Sizes();
		this.options = {
			...options,
			devices: options?.devices || [ 'Desktop', 'Tablet', 'Mobile' ],
		};
		this.isEnable = false;

		// Animations Data
		this.timelines = [];
		this.textInstances = [];

		// Triggers
		this.clickTrigger = {};
		this.clickAgainTrigger = {};
		this.clickFn = [];
		this.clickAgainFn = [];
		this.triggerTimer = [];

		this.clickFuncs = [];
		this.flag = false;
	}

	init() {
		if (
			! this.elements?.length ||
			this.isEnable ||
			! this.options.devices.includes( this.sizes.device )
		)
			return;
		const clickSettings = this.options.click;
		const clickAgainSettings = this.options.clickAgain;
		this.elements.forEach( ( ele, index ) => {
			// Generate Animations
			const [ theTimelines, theTextInstance ] = generateAnimations(
				ele,
				this.options.animations
			);
			this.timelines[ index ] = theTimelines;
			this.textInstances[ index ] = theTextInstance;

			// Triggers
			this.clickFn[ index ] = generateTriggers(
				clickSettings,
				this.timelines[ index ],
				this.clickTrigger,
				this.triggerTimer,
				index
			);

			this.clickAgainFn[ index ] = generateTriggers(
				clickAgainSettings,
				this.timelines[ index ],
				this.clickAgainTrigger,
				this.triggerTimer,
				index
			);

			// Add Events
			this.clickFuncs[ index ] = () => this.#click( index );
			ele.addEventListener( 'click', this.clickFuncs[ index ] );
		} );
		this.isEnable = true;
	}

	kill() {
		if ( ! this.isEnable ) return;
		this.elements.forEach( ( ele, index ) => {
			ele.removeEventListener( 'click', this.clickFuncs[ index ] );
			this.clickFn[ index ]?.kill();
			this.clickAgainFn[ index ]?.kill();
		} );
		destroyAnimations(
			this.elements,
			this.options.animations,
			this.timelines,
			this.textInstances
		);
		this.timelines = [];
		this.textInstances = [];
		this.clickTrigger = {};
		this.clickAgainTrigger = {};
		this.clickFn = [];
		this.clickAgainFn = [];
		this.triggerTimer = [];
		this.clickFuncs = [];
		this.flag = false;
		this.isEnable = false;
	}

	resize() {
		this.kill();
		this.init();
	}

	destroy() {
		this.kill();
		this.elements = null;
		this.sizes = null;
		this.options = null;
		this.isEnable = null;
		this.timelines = null;
		this.textInstances = null;
		this.clickTrigger = null;
		this.clickAgainTrigger = null;
		this.clickFn = null;
		this.clickAgainFn = null;
		this.triggerTimer = null;
		this.clickFuncs = null;
		this.flag = null;
	}

	#click( index ) {
		if ( this.options.isToggle ) {
			if ( ! this.flag ) {
				this.clickFn[ index ]?.run();
			} else {
				this.clickAgainFn[ index ]?.run();
			}
			this.flag = ! this.flag;
		} else {
			this.clickFn[ index ]?.run();
		}
	}
}
